<template>
  <div class="no-results">
    No results, try something else
  </div>
</template>

<script>
export default {
  name: 'NoResult',
}
</script>

<style>
.no-results {
  color: white;
  font-size: 0.9em;
  margin-left: 30px;
  justify-self: center;
  align-self: center;
}
</style>